module.exports = __webpack_public_path__ + "img/弈剑.5aaabea7.png";